<template>
<div id="modaleCoordonnees" class="modal_container">
  <div class="modal_background">
    <div class="modal">
      <div class="modal_header">
        <label class="container">
          <h3>Degrés décimaux (DD)</h3>
          <input type="radio" id="dd" checked="checked" name="radio" @change="changeCoords">
          <span class="checkmark"></span>
        </label>
        <span class="icon_close" @click="closeModal()"></span>
      </div>
      <div class="modal_content" :class="{disabledbutton: !dd}">
        <form ref="formDd" v-on:submit.prevent>
          <div>
            <label for="latitude">Latitude</label>
            <input type="number" name="latitude" id="latitude" :disabled="!dd" v-model="latitude" step="0.000000001" required>
          </div>
          <div>
            <label for="longitude">Longitude</label>
            <input type="number" name="longitude" id="longitude" :disabled="!dd" v-model="longitude" step="0.000000001" required>
          </div>
        </form>
      </div>
      <div class="modal_header">
        <label class="container">
          <h3>Degrés minutes secondes (Dms)</h3>
          <input type="radio" id="dms" name="radio" @change="changeCoords">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="modal_content" :class="{disabledbutton: dd}">
        <form class="formDms" ref="formDms" v-on:submit.prevent>
          <div>
            <label for="laDegres">Latitude</label>
            <span class="inline">
              <input type="radio" id="latN" name="laHemisphere" value="1" v-model="laHemisphere" checked>
              <label for="latN"> N</label>
              <input type="radio" id="latS" name="laHemisphere" value="-1" v-model="laHemisphere">
              <label for="latS"> S</label>
            </span>
            <span> D°<input type="number" name="laDegres" id="laDegres" :disabled="dd" v-model="laDegres" min="0" max="90" required> </span>
            <span> Min<input type="number" name="laMinutes" id="laMinutes" :disabled="dd" v-model="laMinutes" min="0" max="60" required></span>
            <span> Sec <input type="number" name="laSecondes" id="laSecondes" :disabled="dd" v-model="laSecondes" min="0" max="60" step="0.000000001" required></span>
          </div>
          <div>
            <label for="loDegres">Longitude</label>
            <span class="inline">
              <input type="radio" id="lonE" name="loHemisphere" value="1" v-model="loHemisphere" checked>
              <label for="lonE"> E</label>
              <input type="radio" id="lonO" name="loHemisphere" value="-1" v-model="loHemisphere">
              <label for="lonO"> O</label>
            </span>
            <span> D°<input type="number" name="loDegres" id="loDegres" :disabled="dd" v-model="loDegres" min="0" max="180" required> </span>
            <span> Min<input type="number" name="loMinutes" id="loMinutes" :disabled="dd" v-model="loMinutes" min="0" max="60" required></span>
            <span> Sec <input type="number" name="loSecondes" id="loSecondes" :disabled="dd" v-model="loSecondes" min="0" max="60" step="0.000000001" required></span>
          </div>
        </form>
      </div>
      <div class="modal_footer">
        <button type="submit" @click="handleOk()" class="button blue">Valider</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'ModaleCoordonnees',
  components: {},
  data() {
    return {
      latitude: "",
      longitude: "",
      laHemisphere: 1,
      laDegres: "",
      laMinutes: "",
      laSecondes: "",
      loHemisphere: 1,
      loDegres: "",
      loMinutes: "",
      loSecondes: "",
      dd: true
    }
  },

  created() {},
  destroyed() {},
  methods: {
    openModal() {
      var modal = document.getElementById('modaleCoordonnees');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.add('animation');
      body.classList.add('modal_active');
      this.$refs['formDd'].reset();
      this.$refs['formDms'].reset();
    },
    closeModal() {
      var modal = document.getElementById('modaleCoordonnees');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.remove('animation');
      body.classList.remove('modal_active');
      this.latitude = ""
      this.longitude = ""
      this.laHemisphere = ""
      this.laDegres = ""
      this.laMinutes = ""
      this.laSecondes = ""
      this.loHemisphere = 1
      this.loDegres = ""
      this.loMinutes = ""
      this.loSecondes = ""
      this.dd = true
      document.getElementById('dd').checked = true
    },
    handleOk() {
      if (document.getElementById('dd').checked) {
        if (this.$refs['formDd'].checkValidity()) {
          this.$emit('updateCoords', [this.longitude, this.latitude]);
          this.closeModal();
        }
      } else {
        var dmsLat = (Math.abs(parseFloat(this.laDegres)) + (parseInt(this.laMinutes) / 60) + (parseInt(this.laSecondes) / 3600)) * this.laHemisphere;
        var dmsLon = (Math.abs(parseFloat(this.loDegres)) + (parseInt(this.loMinutes) / 60) + (parseInt(this.loSecondes) / 3600)) * this.loHemisphere;
        if (this.$refs['formDms'].checkValidity()) {
          this.$emit('updateCoords', [dmsLon.toString(), dmsLat.toString()]);
          this.closeModal();
        }
      }
    },
    changeCoords() {
      this.dd = !this.dd
      this.latitude = ""
      this.longitude = ""
      this.laHemisphere = 1
      this.laDegres = ""
      this.laMinutes = ""
      this.laSecondes = ""
      this.loHemisphere = 1
      this.loDegres = ""
      this.loMinutes = ""
      this.loSecondes = ""
    }
  }
}
</script>

<style scoped>
form {
  display: flex;
  justify-content: center;
}

form div {
  display: flex;
  flex-direction: column;
  width: 30%;
}

form div:nth-child(1) {
  margin-right: 50px;
}

@media screen and (max-width: 800px) {
  form div {
    width: 70%;
  }
  form div:nth-child(1) {
    margin-right: 25px;
    margin-left: 25px;
  }
}
form div label {
  font-weight: bold;
  font-family: Helvetica, Arial;
  color: #0275d8;
  margin-bottom: 5px;
  padding-left: 2px;
}

form div input {
  width: 100%;
}

.formDms span {
  width: 50%;
  flex-direction: row;
}

.formDms span.inline{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.formDms span.inline input{
  width: 15px;
  margin-top: 0;
  margin-left: 0;
}

.formDms span.inline label{
  padding-top: 5px;
  margin-right: 5px;
}

.modal_header {
  text-align: left;
}
/* The container */
.container {
  display: inline-block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 0px;
  margin-right: 20%;
  margin-left: 20%;
  cursor: pointer;
  font-size: 22px;
  width: 60%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input~.checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked~.checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.disabledbutton {
  pointer-events: none;
  opacity: 0.4;
}
</style>
